import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ContactInfoSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary h-[80px] w-[80px] min-w-[80px] animate-pulse rounded-full text-transparent">.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full items-center gap-3 lg:w-1/2">{t0}<div className="flex w-full flex-col gap-1"><div className="bg-skeleton-primary h-[18px] animate-pulse animate-pulse rounded-md py-0 text-transparent">6</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full flex-col gap-5 lg:flex-row">{t1}<div className="ml-[92px] flex w-[calc(100%-92px)] flex-col gap-1 lg:ml-0 lg:w-1/2"><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div><div className="bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent">.</div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default ContactInfoSkeleton;